// AppContext.js
import React, {
  createContext,
  useState,
  useEffect,
  useRef,
  useContext,
} from "react";
import moment from "moment";

// Create the context
export const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const storedUser = JSON.parse(localStorage.getItem("user")) ?? null;
  const storedToken = localStorage.getItem("token") ?? null;

  // Parse the language as JSON to handle quoted strings
  let storedLang = "en"; // Default
  try {
    const langFromStorage = localStorage.getItem("lang");
    if (langFromStorage) {
      storedLang = JSON.parse(langFromStorage);
    }
  } catch (e) {
    storedLang = "en";
  }

  const [User, setUser] = useState(storedUser);
  const [Token, setToken] = useState(storedToken);
  const [Lang, setLang] = useState(storedLang);
  const [AllData, setAllData] = useState(null); // Store all contractor data here

  const removeUser = () => {
    try {
      //   localStorage.removeItem("User");
      //   setUser(null);
      console.log("✅ User removed!");
    } catch (e) {
      console.error("❌ Failed to remove user", e);
    }
  };

  // Save language to localStorage as JSON string when it changes
  useEffect(() => {
    if (Lang) {
      localStorage.setItem("lang", JSON.stringify(Lang));
    }
  }, [Lang]);

  useEffect(() => {
    //removeUser();
  }, []);

  return (
    <AppContext.Provider
      value={{
        User,
        setUser,
        Token,
        setToken,
        Lang,
        setLang,
        AllData,
        setAllData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
